<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex type2">
        {{ $t('application.temporaryprotection.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('application.title') }} > </span>
            <span class="middle_loc">{{ $t('application.temporaryprotection.title2') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>

      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type3">
            <v-flex class="step_box step01 cursor_pointer" @click="fnGoBefore()">
              <h2>{{ $t('application.temporaryprotection.fields.step_01') }}</h2>
              <p>
                {{ $t('application.temporaryprotection.fields.select_type_and_input') }}<br/>
                {{ $t('application.temporaryprotection.fields.related_application') }}
              </p>
            </v-flex>
            <v-flex class="active step_box step02">
              <h2>{{ $t('application.temporaryprotection.fields.step_02') }}</h2>
              <p>{{ $t('application.temporaryprotection.fields.write_application') }}</p>
            </v-flex>
            <v-flex class="step_box step03">
              <h2>{{ $t('application.temporaryprotection.fields.step_03') }}</h2>
              <p>{{ $t('application.temporaryprotection.fields.attach_files') }}</p>
            </v-flex>
            <v-flex class="step_box step04">
              <h2>{{ $t('application.temporaryprotection.fields.step_04') }}</h2>
              <p>{{ $t('application.temporaryprotection.fields.review_submit') }}</p>
            </v-flex>
            <v-flex class="step_box step05">
              <h2>{{ $t('application.temporaryprotection.fields.step_05') }}</h2>
              <p>{{ $t('application.temporaryprotection.fields.payment') }}</p>
            </v-flex>
          </v-layout>

          <v-layout class="inner_contents mt-30" column>
            <v-flex>
              <h3 class="sub_title_box">{{ $t('application.temporaryprotection.fields.applicants') }}</h3>

              <Applicants
                :receipt_no.sync="receipt_no"
                :userInfo="userInfo"
                :company="company"
                :auto_insert="auto_insert_applicant"
                v-if="flag_applicant"
                ref="component_applicants"
                @success="fnRefreshComponents"
              />
            </v-flex>

            <v-flex class="mt-25">
              <h3 class="sub_title_box">
                {{ $t('application.temporaryprotection.fields.inventors') }}
                <v-spacer></v-spacer>
                <v-btn
                  color="#333"
                  dark
                  outlined
                  height="25"
                  class="btn-normal ft-size11"
                  @click="getApplicantForInventor()"
                >
                  {{ $t('application.temporaryprotection.fields.get_applicants') }}
                </v-btn>
                <v-spacer class="hidden_lr5"></v-spacer>
              </h3>
              <Inventor
                :receipt_no.sync="receipt_no"
                :userInfo="userInfo"
                :company="company"
                v-if="flag_inventor"
                ref="component_inventors"
                @success="fnRefreshComponents"
              />
            </v-flex>

            <v-flex>
              <h3 class="sub_title_box mt-25">
                {{ $t('application.temporaryprotection.fields.representative') }}
                <v-spacer></v-spacer>
                <v-btn
                  color="#333"
                  dark
                  outlined
                  height="25"
                  class="btn-normal ft-size11"
                  @click="getApplicantForRepresentative()"
                  v-show="isNewable"
                >
                  {{ $t('application.temporaryprotection.fields.get_applicants') }}
                </v-btn>
                <v-spacer class="hidden_lr5"></v-spacer>
              </h3>
              <Representative
                :receipt_no.sync="receipt_no"
                :userInfo="userInfo"
                :company="company"
                :auto_insert="auto_insert_representative"
                v-if="flag_representative"
                ref="component_representative"
                @success="fnRefreshComponents"
                @SET_REPRESENTATIVE_NEWABLE="fnSetRepresentativeNewable"
              />
            </v-flex>
          </v-layout>


          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-btn
                dense
                dark
                color="#acb0b3"
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoBefore()"
                :loading="loadingBefore"
                :disabled="loadingBefore"
              >{{ $t('common.button.before') }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnNext()"
                :loading="loadingNext"
                :disabled="loadingNext"
              >
                {{ $t('common.button.next') }}
                <v-icon dark right>mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-layout>

    <!-- dialog_get_applicants_inventor -->
    <v-dialog
      v-model="dialog_get_applicants_inventor"
      flat
      persistent
      max-width="900"
      content-class="br_none"
    >

      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title">{{ $t('application.temporaryprotection.fields.get_applicants') }}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="dialog_get_applicants_inventor = false"></v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-layout class="login_wrap type2 modal_type">
        <v-flex class="pa-0 login_content type2">
          <perfect-scrollbar ref="pfscroll" class="h420" style="width: 100%; padding-left: 30px; padding-right: 30px;">
            <v-data-table
              :headers="$getHeaderType1(headerTxt, headers)"
              :items="applicants_inventor"
              hide-default-footer
              :items-per-page="5"
              class="new__type__table"
              :mobile-breakpoint="MobileBreakPoint"
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <p>{{ item.name_ar }}</p>
                    <p>{{ item.name_en }}</p>
                  </td>
                  <td :class="$vuetify.rtl ? 'text-left' : 'text-right' ">
                    <p>{{ item.address_ar }}</p>
                    <p>{{ item.address_en }}</p>
                  </td>
                  <td>
                      {{ item.applicant_type_code }}
                  </td>
                  <td>
                    {{ item.residence_country_code }}
                  </td>
                  <td>
                    <div class="d-flex">
                      <v-btn
                        color="#a01c2a"
                        dark
                        class="btn-normal br_none ft-size11"
                        @click="fnAddInventorFromApplicant(item.seq)"
                      >
                        {{ $t('common.button.add')}}
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </perfect-scrollbar>
        </v-flex>
      </v-layout>
    </v-dialog>

    <!-- dialog_get_applicants_representative -->
    <v-dialog
      v-model="dialog_get_applicants_representative"
      flat
      persistent
      max-width="900"
      content-class="br_none"
    >
      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title">{{ $t('application.temporaryprotection.fields.get_applicants') }}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="dialog_get_applicants_representative = false"></v-btn>
            </div>
          </div>
        </v-col>
      </v-row>


      <v-layout class="login_wrap type2 modal_type">
        <v-flex class="pa-0 login_content type2">
          <perfect-scrollbar ref="pfscroll" class="h420" style="width: 100%; padding-left: 30px; padding-right: 30px;">
            <v-data-table
              :headers="$getHeaderType1(headerTxt, headers)"
              :items="applicants_representative"
              hide-default-footer
              :items-per-page="5"
              :mobile-breakpoint="MobileBreakPoint"
              class="new__type__table"
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <p>{{ item.name_ar }}</p>
                    <p>{{ item.name_en }}</p>
                  </td>
                  <td :class="$vuetify.rtl ? 'text-right' : 'text-left' ">
                    <p>{{ item.address_ar }}</p>
                    <p>{{ item.address_en }}</p>
                  </td>
                  <td>
                      {{ item.applicant_type_code }}
                  </td>
                  <td>
                    {{ item.residence_country_code }}
                  </td>
                  <td>
                    <div class="d-flex">
                      <v-btn
                        color="#a01c2a"
                        dark
                        class="btn-normal br_none ft-size11"
                        @click="fnShowRepresentativeForm(item.seq)"
                      >
                        {{ $t('common.button.add')}}
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </perfect-scrollbar>
        </v-flex>
      </v-layout>
    </v-dialog>

    <RepresentativeAdd
      :receipt_no.sync="receipt_no"
      :addParams.sync="addParams"
      v-if="dialog_representative_form"
      @success="fnSuccessAddRepresentative"
    />

  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import Applicants from '@/components/layout/Applicants'
import Inventor from '@/components/layout/Inventor'
import Representative from '@/components/layout/Representative'
import RepresentativeAdd from '@/components/layout/RepresentativeAdd'

export default {
  components :{
      Applicants,
      Inventor,
      Representative,
      RepresentativeAdd
  },
  data (){
    return {
      MobileBreakPoint:0,
      dialog_get_applicants_inventor : false,
      dialog_get_applicants_representative : false,
      dialog_representative_form : false,
      isNewable: true,
      loadingBefore: false,
      loadingNext: false,

      headerTxt : {
        prefix : 'application.temporaryprotection.fields.',
        txt : [ '#', 'name','address','applicant_type','residence','' ]
      },

      headers: [
        { text: '#', align: 'center', width: '50', sortable: false},
        { text: 'Name', align: 'center', width:'120', sortable: false },
        { text: 'Address', align: 'center', sortable: false },
        { text: 'Applicant Type', align: 'center', width: '125', sortable: false },
        { text: 'Residence',  align: 'center', width: '98', sortable: false },
        { text: '',  align: 'center', width: '100px', sortable: false }
      ],
      applicants: [],
      applicants_inventor: [],
      applicants_representative: [],

      receipt_no : '',

      auto_insert_applicant : false,
      auto_insert_representative : false,

      seq : 0,
      flag_applicant : false,
      flag_inventor : false,
      flag_representative : false,

      userInfo : {
        seq : '',
        company_seq : '',
        email : '',
        lasted_login_date : '',
        login_failed_count : '',
        account_lock_date : '',
        user_status_type_code : '',
        name_ar : '',
        name_en : '',
        personal_identify_no : '',
        valid_until_date : '',
        strong_auth_type_code : '',
        user_group_type_code : '',
        user_type_code : '',
        agent_no : '',
        birthday_date : '',
        gender_type_code : '',
        id_card_file_key : '',
        id_card_file_name: '',
        student_id_file_key: '',
        student_id_file_name: '',
        address_ar : '',
        address_en : '',
        city_name_ar : '',
        city_name_en : '',
        residence_country_code : '',
        pobox : '',
        postal : '',
        nationality_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        avatar_file_key : '',
        sign_image : '',
        ind_representative : '',
        agent_authorization_type_code : '',
        ind_active : ''
      },

      company : {
        seq : '',
        company_type_code : '',
        company_regiration_no : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        city_name_ar : '',
        city_name_en : '',
        residence_country_code : '',
        residence_country_name_ar : '',
        residence_country_name_en : '',
        pobox : '',
        postal : '',
        registry_cert_file_key : '',
        registry_cert_file_name : '',
        registry_cert_file_ext : '',
        company_status_type_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        representative_email : ''
      },

      addParams : {
        nationality_code : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        pobox_ar : '',
        pobox_en : '',
        birthday_date : '',
        gender_type_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        email : '',
        agent_no : '',
        rep_scope_type_code : '',
        poa_upload_type_code : '',
        poa_reference_app_no : '',
        poa_file_key : '',
        applicants : []
      }

    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.receipt_no = this.$route.params.receipt_no

    this.fnGetReceipt()
    this.fnInit()
  },
  methods: {
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6401'
              || res.data.receipt_status_type_code !== '4301'
              || res.data.receipt_step < 2) {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnInit(){
      //사용자정보 조회
      requestApi({
        url: '/users/profile',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.userInfo.seq = res.data.seq
            this.userInfo.company_seq = res.data.company_seq
            this.userInfo.email = res.data.email
            this.userInfo.lasted_login_date = res.data.lasted_login_date
            this.userInfo.login_failed_count = res.data.login_failed_count
            this.userInfo.account_lock_date = res.data.account_lock_date
            this.userInfo.user_status_type_code = res.data.user_status_type_code
            this.userInfo.name_ar = res.data.name_ar
            this.userInfo.name_en = res.data.name_en
            this.userInfo.personal_identify_no = res.data.personal_identify_no
            this.userInfo.valid_until_date = res.data.valid_until_date
            this.userInfo.strong_auth_type_code = res.data.strong_auth_type_code
            this.userInfo.user_group_type_code = res.data.user_group_type_code
            this.userInfo.user_type_code = res.data.user_type_code
            this.userInfo.agent_no = res.data.agent_no
            this.userInfo.birthday_date = res.data.birthday_date
            this.userInfo.gender_type_code = res.data.gender_type_code
            this.userInfo.id_card_file_key = res.data.id_card_file_key
            this.userInfo.id_card_file_name = res.data.id_card_file_name
            this.userInfo.student_id_file_key = res.data.student_id_file_key
            this.userInfo.student_id_file_name = res.data.student_id_file_name
            this.userInfo.address_ar = res.data.address_ar
            this.userInfo.address_en = res.data.address_en
            this.userInfo.city_name_ar = res.data.city_name_ar
            this.userInfo.city_name_en = res.data.city_name_en
            this.userInfo.residence_country_code = res.data.residence_country_code
            this.userInfo.pobox = res.data.pobox
            this.userInfo.postal = res.data.postal
            this.userInfo.nationality_code = res.data.nationality_code
            this.userInfo.telephone = res.data.telephone
            this.userInfo.mobile = res.data.mobile
            this.userInfo.fax = res.data.fax
            this.userInfo.avatar_file_key = res.data.avatar_file_key
            this.userInfo.sign_image = res.data.sign_image
            this.userInfo.ind_representative = res.data.ind_representative
            this.userInfo.agent_authorization_type_code = res.data.agent_authorization_type_code
            this.userInfo.ind_active = res.data.ind_active

            if(res.data.user_type_code != '2704' && res.data.user_type_code != '2705' ){
              //개인 사용자가 아니라면(company거나 agent) 회사 정보도 가져온다
              requestApi({
                url: '/users/company/information',
                method: 'GET',
                callback: (res) => {
                  if (res.res_code === '200') {
                    this.company.seq = res.data.seq
                    this.company.company_type_code = res.data.company_type_code
                    this.company.company_regiration_no = res.data.company_regiration_no
                    this.company.name_ar = res.data.name_ar
                    this.company.name_en = res.data.name_en
                    this.company.address_ar = res.data.address_ar
                    this.company.address_en = res.data.address_en
                    this.company.city_name_ar = res.data.city_name_ar
                    this.company.city_name_en = res.data.city_name_en
                    this.company.residence_country_code = res.data.residence_country_code
                    this.company.residence_country_name_ar = res.data.residence_country_name_ar
                    this.company.residence_country_name_en = res.data.residence_country_name_en
                    this.company.pobox = res.data.pobox
                    this.company.postal = res.data.postal
                    this.company.registry_cert_file_key = res.data.registry_cert_file_key
                    this.company.registry_cert_file_name = res.data.registry_cert_file_name
                    this.company.registry_cert_file_ext = res.data.registry_cert_file_ext
                    this.company.company_status_type_code = res.data.company_status_type_code
                    this.company.telephone = res.data.telephone
                    this.company.mobile = res.data.mobile
                    this.company.fax = res.data.fax
                    this.company.representative_email = res.data.representative_email

                    //Temporary Application Application 조회
                    this.fnGetTemporaryApplication()

                  }else{
                    if (res.res_code === '401012') {
                      utils.setTokenRefresh().then(() => {
                        this.fnInit()
                      })
                    } else {
                      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                    }
                  }
                }
              })
            }else{
              //Temporary Application Application 조회
              this.fnGetTemporaryApplication()
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnInit()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    //Temporary Application Application 조회
    fnGetTemporaryApplication(){

      //사용자정보 조회 후 사용자 구분에 따라 applicant와 representative의 최초 자동인서트 여부를 결정한다
      if(this.userInfo.user_group_type_code == '3801' || this.userInfo.user_group_type_code == '3802'){
        //개인회원 이거나 COMPANY회원 이라면
        this.auto_insert_applicant = true
        this.auto_insert_representative = false
      }

      if(this.userInfo.user_group_type_code == '3803' || this.userInfo.user_group_type_code == '3804'){
        //AGENT라면
        this.auto_insert_applicant = false
        this.auto_insert_representative = true
      }

      this.flag_applicant = true
      this.flag_inventor = true
      this.flag_representative = true
      //this.flag_correspondence = true
    },

    fnGoBefore(){
      this.loadingBefore = true
      this.$router.push("/application/temporaryprotection/step1/"+this.receipt_no)
    },

    fnNext(){
      if(this.$refs.component_applicants.applicants.length < 1){
        let option = {
          text : this.$t('component.applicants.msg_validate_fail_size'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      if(this.$refs.component_inventors.inventors.length < 1){
        let option = {
          text : this.$t('component.inventor.msg_validate_fail_size'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      if(this.$refs.component_representative.representatives.length < 1){
        let option = {
          text : this.$t('component.representative.msg_validate_fail_size'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      if(this.$refs.component_applicants.auto_exist_yn){
        let option = {
          text : this.$t('component.applicants.msg_auto_check'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      if(this.$refs.component_inventors.auto_exist_yn){
        let option = {
          text : this.$t('component.inventor.msg_auto_check'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      if(this.$refs.component_representative.auto_exist_yn){
        let option = {
          text : this.$t('component.representative.msg_auto_check'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      this.loadingNext = true
      requestApi({
        url: '/receivings/temporary/'+this.receipt_no+'/application',
        method: 'PUT',
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.$router.push("/application/temporaryprotection/step3/"+this.receipt_no)
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnNext()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              this.loadingNext = false
            }
          }
        }
      })


    },

    fnRefreshComponents(){
      this.$refs.component_applicants.fnGetApplicants()
      this.$refs.component_inventors.fnGetInventors()
      this.$refs.component_representative.fnGetRepresentatives()
      //this.$refs.component_correspondence.fnGetCorrespondences()
    },

    fnSuccessAddRepresentative(){
      this.dialog_representative_form = false
      this.$refs.component_representative.fnSuccess()
    },

    getApplicantForInventor(){

      requestApi({
        url: '/receivings/'+this.receipt_no+'/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.applicants_inventor = []

            //타입이 Company이거나 SmallCompany가 아닌 Applicants
            let applicantList = []
            for(let k=0; k<res.data.list.length; k++){
              if(res.data.list[k].applicant_type_code != '2701' && res.data.list[k].applicant_type_code != '2702'){
                applicantList.push(res.data.list[k])
              }
            }

            //inventor 리스트를 구해온다.
            requestApi({
              url: '/receivings/'+this.receipt_no+'/inventors',
              method: 'GET',
              callback: (res) => {
                if(res.res_code === '200'){

                  let inventorList = res.data.list

                  for(let i=0; i<applicantList.length; i++){

                    let flag = true

                    for(let k=0; k<inventorList.length; k++){
                      if(applicantList[i].seq == inventorList[k].applicant_seq){
                        flag = false
                      }
                    }

                    if(flag){
                      this.applicants_inventor.push(applicantList[i])
                    }
                  }

                }else{
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.getApplicantForInventor()
                    })
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.getApplicantForInventor()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

      this.dialog_get_applicants_inventor = true
    },

    fnAddInventorFromApplicant(seq){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/applicants/'+seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            let params = {
              nationality_code : res.data.nationality_code,
              residence_country_code : res.data.residence_country_code,
              name_ar : res.data.name_ar,
              name_en : res.data.name_en,
              address_ar : res.data.address_ar,
              address_en : res.data.address_en,
              pobox_ar : res.data.pobox_ar,
              pobox_en : res.data.pobox_en,
              birthday_date : res.data.birthday_date,
              gender_type_code : res.data.gender_type_code,
              telephone : res.data.telephone,
              mobile : res.data.mobile,
              fax : res.data.fax,
              email : res.data.email,
              applicant_seq : res.data.seq
            }

            requestApi({
              url: '/receivings/'+this.receipt_no+'/inventors',
              method: 'POST',
              data: params,
              callback: (res) => {
                if (res.res_code === '200') {
                  //등록 하고 나서 컴포넌트의 석세스함수를 호출
                  this.$refs.component_inventors.fnSuccess()
                  this.dialog_get_applicants_inventor = false
                } else {
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.fnAddInventorFromApplicant(seq)
                    })
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnAddInventorFromApplicant(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    getApplicantForRepresentative(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            //this.applicants_representative = res.data.list
            this.applicants_representative = []

            let all_applicants = res.data.list

            requestApi({
              url: '/receivings/'+this.receipt_no+'/representatives',
              method: 'GET',
              callback: (res) => {
                if (res.res_code === '200') {
                  let used_applicants = []
                  let flag_all = false

                  for(let i=0; i<res.data.list.length; i++){
                    if(res.data.list[i].rep_scope_type_code == '5101'){
                      flag_all = true
                    }else{
                      for(let k=0; k<res.data.list[i].applicants.length; k++){
                        used_applicants.push(res.data.list[i].applicants[k])
                      }
                    }
                  }
                  if(flag_all){
                    this.applicants_representative = []
                  }else{


                    for(let i=0; i<all_applicants.length; i++){
                      let flag_used = false

                      for(let k=0; k<used_applicants.length; k++){
                        if(all_applicants[i].seq == used_applicants[k].seq ){
                          flag_used = true
                        }
                      }

                      if(!flag_used){
                        this.applicants_representative.push(all_applicants[i])
                      }
                    }
                  }
                }else{
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.getApplicantForRepresentative()
                    })
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.getApplicantForRepresentative()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

      this.dialog_get_applicants_representative = true
    },

    fnShowRepresentativeForm(seq){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/applicants/'+seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.addParams.nationality_code = res.data.nationality_code
            this.addParams.residence_country_code = res.data.residence_country_code
            this.addParams.name_ar = res.data.name_ar
            this.addParams.name_en = res.data.name_en
            this.addParams.address_ar = res.data.address_ar
            this.addParams.address_en = res.data.address_en
            this.addParams.pobox_ar = res.data.pobox_ar
            this.addParams.pobox_en = res.data.pobox_en
            this.addParams.birthday_date = res.data.birthday_date
            this.addParams.gender_type_code = res.data.gender_type_code
            this.addParams.telephone = res.data.telephone
            this.addParams.mobile = res.data.mobile
            this.addParams.fax = res.data.fax
            this.addParams.email = res.data.email
            this.addParams.agent_no = res.data.agent_no
            this.addParams.rep_scope_type_code = '5101'

            this.dialog_get_applicants_representative = false
            this.dialog_representative_form = true
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnShowRepresentativeForm(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSetRepresentativeNewable(isNewable){
      this.isNewable = isNewable
    }


  }
}
</script>